import React from 'react';
import { TableCell } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { darken, alpha, lighten } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
  totalRow: {
    background: theme.palette.grey[50],
    position: 'sticky',
    bottom: 0,
    borderLeft: `1px solid
    ${
      theme.palette.mode === 'light'
        ? lighten(alpha(theme.palette.divider, 1), 0.97)
        : darken(alpha(theme.palette.divider, 1), 0.68)
    }`,
  },
}));

const TableTotalCell = props => {
  const classes = useStyles();
  const { colSpan } = props;
  return (
    <TableCell colSpan={colSpan} className={classes.totalRow}>
      {props.children}
    </TableCell>
  );
};

export default TableTotalCell;
